import React from 'react';
import TrackMap from '../TrackMap';

// Feed-neutral presentation for both Live and later shared delayed playback.
// Geometry and position coordinate transform belong entirely to TrackMap.
export default function MapStage({ outline, carPositions = {}, teamColours, topOrder, circuit, source, stale, statusLabel }) {
  const hasCars = Object.values(carPositions).some(point => point && Number.isFinite(point.x) && Number.isFinite(point.y));
  const disconnected = source === 'connecting' || source === 'disconnected';
  const freshness = disconnected ? 'CONNECTING' : stale ? 'STALE POSITIONS' : 'LIVE POSITIONS';
  return (
    <section className="pw3-map-stage" aria-label="Circuit live map">
      <header className="pw3-map-meta">
        <span className="pw3-map-circuit" title={circuit || undefined}>{circuit || 'Circuit'}</span>
        <div className="pw3-map-status">
          <span className={`pw3-freshness ${stale || disconnected ? 'pw3-stale' : ''}`}>{statusLabel ?? freshness}</span>
          <span className="pw3-source">SOURCE: {source ? String(source).toUpperCase() : 'UNKNOWN'}</span>
        </div>
      </header>
      <div className="pw3-map-canvas">
        {outline ? <TrackMap outline={outline} carPositions={carPositions} teamColours={teamColours} topOrder={topOrder} /> : (
          <div className="pw3-unavailable">TRACK MAP UNAVAILABLE <small>No circuit outline received</small></div>
        )}
        {outline && !hasCars && <div className="pw3-waiting">WAITING FOR CAR POSITIONS</div>}
      </div>
    </section>
  );
}
